/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Form, Grid, Button, Pagination, Icon, Loader, Popup } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const ipRegex = new RegExp("^[0-2][0-9.]*$");
const eventRegex = new RegExp("^[0-9][0-9]*$");
const nameRegex = new RegExp("^[A-Za-z][A-Za-z- ]*");

const logListBeginMultiplier = 50;
const logListEndMultiplier = 49;

const UtilsInstance = new Utils();
var cameFromLiveListClick = false;
var shouldPaintRowWithGreyColor = true;

var timeNow = new Date().getTime();

class EventLog extends Component {

  // Intialize this component state with an empty log list
  constructor(props) {
    super(props);
    this.state = {
      originalLogList: [],
      activeLogList: [],
      filteredLogList: [],
      currentPage: 1,
      isLoadingActive: false
    };
    cameFromLiveListClick = false;
  }

  showLoading = () => this.setState({ isLoadingActive: true });
  hideLoading = () => this.setState({ isLoadingActive: false });

  handleIPSearch = (formInput) => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalLogList[i].ip === formInput) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
    }
    // Show all entries that matched the IP on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  };

  handleEventSearch = (formInput) => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalLogList[i].event.toString() === formInput.toString()) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
    }
    // Show all entries that matched the event number on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  };

  handleNameSearch = (formInput) => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    for (let i = 0; i < len; i++) {
      let noWhitespaceUppercasedDeviceName = this.state.originalLogList[i].name.toUpperCase().replace(/\s/g, "");
      let noWhitespaceUppercasedDeviceModel = this.state.originalLogList[i].model.toUpperCase().replace(/\s/g, "");
      let noWhitespaceUppercasedFormInput = formInput.toUpperCase().replace(/\s/g, "");

      // Uppercases both strings before comparison to allow search flexibility
      // Also remove all whitespaces in both strings before comparing
      if (noWhitespaceUppercasedDeviceName.toUpperCase().indexOf(noWhitespaceUppercasedFormInput) !== -1) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
      else if (noWhitespaceUppercasedDeviceModel.toUpperCase().indexOf(noWhitespaceUppercasedFormInput) !== -1) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
    }
    // Show entries that matched the name on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  };

  // Refreshes the page
  handleRefreshButtonClick = () => {
    this.setState({ filteredLogList: [], currentPage: 1 }, () => {
      document.getElementById("inputform").value = "";
      this.retrieveData();
    });
  };

  /*
    Handles user form submit 
    Filters the page list showing only the devices that match the
    ip or name the user has typed
  */
  handleSubmit = () => {
    let formInput = document.getElementById("inputform").value;

    // Before doing any searches we empty the filtered log list and set
    // the current page to 1 to avoid problems
    this.setState({ filteredLogList: [], currentPage: 1 }, () => {
      if (formInput !== "" && eventRegex.test(formInput)) {
        this.handleEventSearch(formInput);
      }
      else if (formInput !== "" && ipRegex.test(formInput)) {
        this.handleIPSearch(formInput);
      }
      else if (formInput !== "" && nameRegex.test(formInput)) {
        this.handleNameSearch(formInput);
      }
      else if (formInput === "") {
        this.buildAndRenderPagination(this.state.originalLogList.length);
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
      else {
        alert(Strings.INSERT_VALID_EVENT_OR_NAME_OR_IP);
      }
    });
  };

  // Creates a list with all log entries that match the IP received from 
  // a click on the live list status cell
  handleCellStatusIPSearch = () => {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.deviceIP !== undefined) {
        cameFromLiveListClick = true;
        const len = this.state.originalLogList.length;
        const searchedEntries = [];

        for (let i = 0; i < len; i++) {
          if (this.state.originalLogList[i].ip === this.props.location.state.deviceIP) {
            searchedEntries.push(this.state.originalLogList[i]);
          }
        }
        // Show all log entries that matched the IP or none
        if (searchedEntries.length > 0) {
          this.setState({ filteredLogList: searchedEntries }, () => {
            this.buildAndRenderPagination(this.state.filteredLogList.length);
            this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
          });
        } else {
          this.setState({ filteredLogList: [] }, () => {
            this.buildAndRenderPagination(this.state.filteredLogList.length);
            this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
          });
        }
      }
    }
  };

  retrieveData = () => {
    timeNow = new Date().getTime();
    this.showLoading();
    // Retrieve paginated log
    fetch(Constants.REQUEST_IP_ADDRESS + "log", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ originalLogList: this.adjustLogData(data) }, () => {
        this.hideLoading();
        this.handleCellStatusIPSearch();
        if (!cameFromLiveListClick) {
          this.buildAndRenderPagination(data.length);
          this.buildAndRenderActiveLogPage(this.state.currentPage);
        }
      }))
      .catch((error) => {
        console.log(error);
        this.hideLoading();
        this.setState({ originalLogList: [] });
        this.buildAndRenderPagination(0);
        this.buildAndRenderActiveLogPage(1);
      });
  };

  adjustLogData = (logList) => {
    let logListCopy = JSON.parse(JSON.stringify(logList));

    for (let i = 0; i < logListCopy.length; i++) {
      if (logListCopy[i].ip === null) {
        logListCopy[i].ip = "None";
      }

      if (logListCopy[i].model === null) {
        logListCopy[i].model = "None";
      }

      if (logListCopy[i].name === null) {
        logListCopy[i].name = "None";
      }
    }

    return logListCopy;
  };

  formatTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      const eventTimeInMillis = logEntry.time * 1000;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  };

  /*
    Each page will show a maximum of 50 log entries
  */
  buildAndRenderPagination = (numOfLogEntries) => {
    // The number of pages should be the highest integer number after (log entries / 50)
    const numOfPages = Math.ceil(numOfLogEntries / 50);
    const pagination = <Pagination
      firstItem={null}
      lastItem={null}
      boundaryRange={1}
      defaultActivePage={this.state.currentPage}
      siblingRange={1}
      totalPages={numOfPages}
      onPageChange={this.handlePageChange} />;
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(pagination, document.getElementById("pagination-container"));
  };

  handlePageChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage }, () => {
      // If the user came from a livelist click or has filtered the log
      if (cameFromLiveListClick || this.state.filteredLogList.length > 0) {
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      }
      else {
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
    });
  };

  buildAndRenderActiveLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.originalLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.originalLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  };

  buildAndRenderActiveFilteredLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.filteredLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.filteredLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  };

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * 0.67;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  };

  // Returns the alarm text and a circle icon next to it indicating the 
  // severity of the alarm
  getAlarmColorAndText = (alarm) => {
    let returnIcon = "";
    let alarmText = "";
    let alarmChannel = "";
    let tipText = "";

    if (alarm.channel !== null) {
      alarmChannel = alarm.channel + ": ";
    }

    if (alarm.unknown === true) {
      alarmText = Strings.FROM_GSDML + alarm.array[0] + Strings.MANUFACTURER_TIP;

      for (let i = 1; i < alarm.array.length; i++) {
        let lowercaseFirstLetter = alarm.array[i].toLowerCase() + ", ";
        alarmText = alarmText.concat(lowercaseFirstLetter);
      }
      alarmText = alarmText.slice(0, alarmText.length - 2);
      alarmText = alarmText.concat(").");
    }
    else {
      for (let i = 0; i < alarm.array.length; i++) {
        if (i > 0) {
          alarmText = alarmText.concat(alarm.array[i].toLowerCase(), ", ");
        }
        else {
          alarmText = alarmText.concat(alarm.array[i], ", ");
        }
      }
      alarmText = alarmText.slice(0, alarmText.length - 2);
    }

    if (alarm.tip !== undefined && alarm.tip !== null) {
      tipText = <>. (<strong>{Strings.TIP}</strong> {alarm.tip}).</>;
    }

    switch (alarm.severity) {
      case Constants.ALARM_FAILURE:
        returnIcon = <React.Fragment key={Math.random()}>
          <Popup
            trigger={
              <p>
                <Icon name="circle" color="red" />
                {alarmChannel}
                {alarmText}
                {tipText}
                <br />
              </p>
            }
            hideOnScroll
            content={Strings.ALARM_FAILURE_TOOLTIP}
            position='top left'
          />
        </React.Fragment>;
        break;
      case Constants.ALARM_MAINTENANCE_DEMANDED:
        returnIcon = <React.Fragment key={Math.random()}>
          <Popup
            trigger={
              <p>
                <Icon name="circle" color="orange" />
                {alarmChannel}
                {alarmText}
                {tipText}
                <br />
              </p>
            }
            hideOnScroll
            content={Strings.ALARM_MAINTENANCE_DEMANDED_TOOLTIP}
            position='top left'
          />
        </React.Fragment>;
        break;
      case Constants.ALARM_MAINTENANCE_REQUIRED:
        returnIcon = <React.Fragment key={Math.random()}>
          <Popup
            trigger={
              <p>
                <Icon name="circle" color="yellow" />
                {alarmChannel}
                {alarmText}
                {tipText}
                <br />
              </p>
            }
            hideOnScroll
            content={Strings.ALARM_MAINTENANCE_REQUIRED_TOOLTIP}
            position='top left'
          />
        </React.Fragment>;
        break;
      case Constants.ALARM_NONE:
        returnIcon = <React.Fragment key={Math.random()}>
          <Popup
            trigger={
              <p>
                <Icon name="circle" color="grey" />
                {alarmChannel}
                {alarmText}
                {tipText}
                <br />
              </p>
            }
            hideOnScroll
            content={Strings.ALARM_NONE_TOOLTIP}
            position='top left'
          />
        </React.Fragment>;
        break;
      default:
        returnIcon = <React.Fragment key={Math.random()}>
          <Popup
            trigger={
              <p>
                <Icon name="circle" color="black" />
                {alarmChannel}
                {alarmText}
                {tipText}
                <br />
              </p>
            }
            hideOnScroll
            content={Strings.ALARM_NONE_TOOLTIP}
            position='top left'
          />
        </React.Fragment>;
        break;
    }

    return returnIcon;
  };

  getDescriptionTableCell = (logEntry) => {
    // If the description is an object (multiple lines) return a table cell with only 'Alarme' written on it
    if (typeof (logEntry.description) === "object") {
      if (logEntry.description.entrada !== undefined) {
        return (<Table.Cell className="ts-log-event-cell" verticalAlign="middle" width="5"><span className="ts-badge ts-badge-info">{Strings.DEVICE_HAS_JOINED_THE_NETWORK}</span></Table.Cell>);
      }
      else {
        return (<Table.Cell className="ts-log-event-cell" verticalAlign="middle" width="5"><span className="ts-badge ts-badge-info">{Strings.ALARM}</span></Table.Cell>);
      }
    }
    // If the description is a string and contains '->' it is a status change
    else if (typeof (logEntry.description) === "string" && logEntry.description.includes("->")) {
      return (
        <Table.Cell className="ts-log-event-cell" verticalAlign="middle" textAlign="left" width="5">
          <span className="ts-badge ts-badge-info">{Strings.STATUS_CHANGE}</span>
          {logEntry.description}
        </Table.Cell>
      );
    }
    // logEntry.description.split("dispositivo de MAC").length -1 === 2
    // Se essa verificação for true, significa que é um evento de IP duplicado
    else if (typeof (logEntry.description) === "string"
      && ((logEntry.description.split("dispositivo de MAC").length - 1 === 2)
        || logEntry.description.split("device of MAC").length - 1 === 2)) {
      return (
        <Table.Cell className="ts-log-event-cell" verticalAlign="middle" textAlign="left" width="5">
          <span className="ts-badge ts-badge-info">{Strings.DUPLICATE_IP}</span>
          {logEntry.description}
        </Table.Cell>
      );
    }
    // Othwerwise, just return a table cell with the string written on it
    else {
      return (<Table.Cell className="ts-log-event-cell" verticalAlign="middle" textAlign="left" width="5">{logEntry.description}</Table.Cell>);
    }
  };

  getActiveAlarmModuleInfo = (module) => {
    return (
      <React.Fragment key={Math.random()}>
        {module.moduleName}
        {module.activeAlarms}
      </React.Fragment>
    );
  };

  getNotActiveAlarmModuleInfo = (module) => {
    return (
      <React.Fragment key={Math.random()}>
        {module.moduleName}
        {module.notActiveAlarms}
      </React.Fragment>
    );
  };

  // Returns a new row with two columns containing the log description divided between active
  // and not active
  getAlarmDescriptionTableRow = (logEntryDescription, activeLogEntryAlarms, notActiveLogEntryAlarms) => {
    if (typeof (logEntryDescription) === "object") {
      let activeModuleInformation = [];
      let notActiveModuleInformation = [];

      for (let i = 0; i < activeLogEntryAlarms.length; i++) {
        activeModuleInformation.push({
          "moduleName": <p style={alarmTitleFontStyle}> {activeLogEntryAlarms[i].module} {Strings.REPORTING}</p>,
          "activeAlarms": activeLogEntryAlarms[i].contents.map(content => {
            return this.getAlarmColorAndText(content);
          })
        });
      }

      for (let i = 0; i < notActiveLogEntryAlarms.length; i++) {
        notActiveModuleInformation.push({
          "moduleName": <p style={alarmTitleFontStyle}> {notActiveLogEntryAlarms[i].module} {Strings.REPORTING}</p>,
          "notActiveAlarms": notActiveLogEntryAlarms[i].contents.map(content => {
            return this.getAlarmColorAndText(content);
          })
        });
      }

      let activeInformationMap = "";
      let notActiveInformationMap = "";

      if (activeModuleInformation.length === 0) {
        activeInformationMap = <p>{Strings.NO_EVENT}</p>;
      }
      else {
        activeInformationMap = activeModuleInformation.map(moduleInformation => {
          return this.getActiveAlarmModuleInfo(moduleInformation);
        });
      }

      if (notActiveModuleInformation.length === 0) {
        notActiveInformationMap = <p>{Strings.NO_EVENT}</p>;
      }
      else {
        notActiveInformationMap = notActiveModuleInformation.map(moduleInformation => {
          return this.getNotActiveAlarmModuleInfo(moduleInformation);
        });
      }

      // If the row needs to be painted grey
      if (shouldPaintRowWithGreyColor) {
        return (
          <Table.Row className="ts-log-detail-row ts-log-group-end ts-log-row-soft" textAlign="left" key={Math.random()}>
            <Table.Cell className="ts-log-detail-cell" verticalAlign="top" colSpan='3' key={Math.random()}>
              <p style={alarmTitleFontStyle}>{Strings.ACTIVE_DP}</p>
              {activeInformationMap}
            </Table.Cell>
            <Table.Cell className="ts-log-detail-cell" verticalAlign="top" colSpan='2' key={Math.random()}>
              <p style={alarmTitleFontStyle}>{Strings.NOT_ACTIVE_DP}</p>
              {notActiveInformationMap}
            </Table.Cell>
          </Table.Row>
        );
      }
      else {
        return (
          <Table.Row className="ts-log-detail-row ts-log-group-end" textAlign="left" key={Math.random()}>
            <Table.Cell className="ts-log-detail-cell" verticalAlign="top" colSpan='3' key={Math.random()}>
              <p style={alarmTitleFontStyle}>{Strings.ACTIVE_DP}</p>
              {activeInformationMap}
            </Table.Cell>
            <Table.Cell className="ts-log-detail-cell" verticalAlign="top" colSpan='2' key={Math.random()}>
              <p style={alarmTitleFontStyle}>{Strings.NOT_ACTIVE_DP}</p>
              {notActiveInformationMap}
            </Table.Cell>
          </Table.Row>
        );
      }
    }
  };

  getNetworkDeviceEntryTableRow = (entry) => {
    let connections = entry.connections.map(connection => {
      return this.getConnectionInfo(connection);
    });

    return (
      <Table.Row className="ts-log-detail-row ts-log-group-end" textAlign="left" key={Math.random()}>
        <Table.Cell className="ts-log-detail-cell" verticalAlign="top" colSpan='5' key={Math.random()}>
          <p style={alarmTitleFontStyle}>{Strings.DETAILS}</p>
          <p>{Strings.THE_DEVICE} <b>{entry.name}</b> {Strings.OF_IP} <b>{entry.ip}</b> {Strings.JOINED_THE_NETWORK}.</p>
          <ul>{connections}</ul>
        </Table.Cell>
      </Table.Row>
    );
  };

  getConnectionInfo(connection) {
    return (
      <li>
        {Strings.THE_PORT}
        <b> {connection.selfPort} </b>
        {Strings.IS_CONNECTED_WITH_PORT}
        <b> {connection.neighborPort} </b>
        {Strings.FROM_DEVICE}
        <b> {connection.neighborName} </b>
        {Strings.OF_IP}
        <b> {connection.neighborIP}.</b>
      </li>
    );
  }

  getLongDescriptionTableRow = (logEntry) => {
    if (typeof (logEntry.description) === "object" && logEntry.description.alarmeAtivo !== undefined) {
      return this.getAlarmDescriptionTableRow(
        logEntry.description,
        this.getDescendingOrderedActiveLogEntryAlarms(logEntry),
        this.getDescendingOrderedNotActiveLogEntryAlarms(logEntry));
    }
    else if (typeof (logEntry.description) === "object" && logEntry.description.entrada !== undefined) {
      return this.getNetworkDeviceEntryTableRow(logEntry.description.entrada);
    }
  };

  // Returns an array containing the active alarms of a log entry sorted by
  // severity level descending (3:Failure > 2 > 1 > 0:none)
  getDescendingOrderedActiveLogEntryAlarms = (logEntry) => {
    let descendingOrderedLogEntryAlarms = [];

    if (typeof (logEntry.description) === "object") {

      Object.keys(logEntry.description.alarmeAtivo).forEach((key) => {
        descendingOrderedLogEntryAlarms.push(
          {
            "contents": logEntry.description.alarmeAtivo[key],
            "module": key
          }
        );
      });

      for (let i = 0; i < descendingOrderedLogEntryAlarms.length; i++) {
        descendingOrderedLogEntryAlarms[i].contents.sort(UtilsInstance.sortBy("severityNumber", true, parseInt));
      }
    }

    return descendingOrderedLogEntryAlarms;

  };

  // Returns an array containing the non active alarms of a log entry sorted by
  // severity level descending (3:Failure > 2 > 1 > 0:none)
  getDescendingOrderedNotActiveLogEntryAlarms = (logEntry) => {
    let descendingOrderedLogEntryAlarms = [];

    if (typeof (logEntry.description) === "object") {

      Object.keys(logEntry.description.alarmeDesaparecido).forEach((key) => {
        descendingOrderedLogEntryAlarms.push(
          {
            "contents": logEntry.description.alarmeDesaparecido[key],
            "module": key
          }
        );
      });

      for (let i = 0; i < descendingOrderedLogEntryAlarms.length; i++) {
        descendingOrderedLogEntryAlarms[i].contents.sort(UtilsInstance.sortBy("severityNumber", true, parseInt));
      }
    }

    return descendingOrderedLogEntryAlarms;

  };

  // Returns a table row corresponding to the information contained in the
  // log entry
  getLogEntryTableRow = (logEntry) => {
    let tableRow = "";

    // If the row background needs to be painted grey, get it painted
    if (shouldPaintRowWithGreyColor) {
      tableRow = <React.Fragment key={logEntry.event}>
        <Table.Row className="ts-log-summary-row ts-log-group-start ts-log-row-soft" key={logEntry.time}>
          <Table.Cell verticalAlign="middle">{this.formatTime(logEntry)}</Table.Cell>
          <Table.Cell verticalAlign="middle">{UtilsInstance.getDeviceName(logEntry.name, Strings, UtilsInstance)}</Table.Cell>
          <Table.Cell verticalAlign="middle">{UtilsInstance.getDeviceName(logEntry.model, Strings, UtilsInstance)}</Table.Cell>
          <Table.Cell verticalAlign="middle">{UtilsInstance.getDeviceIP(logEntry.ip, Strings)}</Table.Cell>
          {this.getDescriptionTableCell(logEntry)}
        </Table.Row>
        {this.getLongDescriptionTableRow(logEntry)}
      </React.Fragment>;
    }
    // otherwise, get it with a white background
    else {
      tableRow = <React.Fragment key={logEntry.event}>
        <Table.Row className="ts-log-summary-row ts-log-group-start" key={logEntry.time}>
          <Table.Cell verticalAlign="middle">{this.formatTime(logEntry)}</Table.Cell>
          <Table.Cell verticalAlign="middle">{UtilsInstance.getDeviceName(logEntry.name, Strings, UtilsInstance)}</Table.Cell>
          <Table.Cell verticalAlign="middle">{UtilsInstance.getDeviceName(logEntry.model, Strings, UtilsInstance)}</Table.Cell>
          <Table.Cell verticalAlign="middle">{UtilsInstance.getDeviceIP(logEntry.ip, Strings)}</Table.Cell>
          {this.getDescriptionTableCell(logEntry)}
        </Table.Row>
        {this.getLongDescriptionTableRow(logEntry)}
      </React.Fragment>;
    }

    shouldPaintRowWithGreyColor = !shouldPaintRowWithGreyColor;
    return (tableRow);
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.adjustTableMaxHeight();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.adjustTableMaxHeight, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // Render the table containing log entries
  render() {
    const activeLogList = this.state.activeLogList.map(logEntry => (
      this.getLogEntryTableRow(logEntry)
    ));

    return (
      <div style={screenStyle}>

        <Grid id="grid-id" className="ts-page-toolbar ts-log-toolbar" columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row>

            <Grid.Column>
              {
                // Left blank on purpouse so that we don't lose the 3-column grid alignment
              }
            </Grid.Column>

            <Grid.Column>
              <Form className="ts-toolbar-search" style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  placeholder={Strings.LOG_INPUT_TEXT_PLACEHOLDER}
                  id="inputform"
                  icon="search"
                  name="formInput" />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Button
                className="ts-log-refresh-button"
                circular
                icon="refresh"
                color="teal"
                onClick={this.handleRefreshButtonClick} />
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Table id="table-header" className="ts-log-table" style={headerMarginStyle} celled fixed textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                {Strings.HORARY}
              </Table.HeaderCell>

              <Table.HeaderCell>
                {Strings.NAME}
              </Table.HeaderCell>

              <Table.HeaderCell>
                {Strings.MODEL}
              </Table.HeaderCell>

              <Table.HeaderCell>
                {Strings.IP}
              </Table.HeaderCell>

              <Table.HeaderCell width="5">
                {Strings.EVENT_TYPE}
              </Table.HeaderCell>
            </Table.Row>

          </Table.Header>
        </Table>

        <div id="main-table-container" className="ts-log-table-container" style={tableStyle}>
          <Table className="ts-log-table ts-table" celled fixed textAlign="center">
            <Table.Body>{activeLogList}</Table.Body>
          </Table>
        </div>

        <div id="pagination-container"></div>

        <Loader size='big' active={this.state.isLoadingActive}>{Strings.LOG_WAITING}</Loader>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  marginTop: "8px",
  marginLeft: "4px",
  marginRight: "4px",
  textAlign: "center"
};

const tableStyle = {
  overflowY: "scroll",
  marginTop: "16px",
  marginBottom: "16px"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99.5%"
};

const searchStyle = {
  marginBottom: "8px",
  width: "100%"
};

const alarmTitleFontStyle = {
  fontWeight: "bold"
};

export default withRouter(EventLog);
